class DocumentUrlAndBool {
    public IsChecked: boolean;
    public PageSizes: number;
    public PageNumber: number;
}

export { DocumentUrlAndBool };
